export function initScrollNavigation(): void {
  const containers = document.querySelectorAll<HTMLElement>('[data-scroll-container]')

  containers.forEach((container: HTMLElement) => {
    const id: string | undefined = container.dataset.scrollContainer
    if (!id) {return}

    const prevBtn = document.querySelector<HTMLButtonElement>(`[data-scroll-prev="${id}"]`)
    const nextBtn = document.querySelector<HTMLButtonElement>(`[data-scroll-next="${id}"]`)

    if (!prevBtn || !nextBtn) {return}

    const updateButtonStates = (): void => {
      const scrollLeft: number = container.scrollLeft
      const scrollWidth: number = container.scrollWidth
      const clientWidth: number = container.clientWidth
      const maxScroll: number = scrollWidth - clientWidth

      prevBtn.disabled = scrollLeft <= 1

      nextBtn.disabled = scrollLeft >= maxScroll - 1
    }

    const scrollToNext = (): void => {
      const items: HTMLElement[] = Array.from(
        container.querySelectorAll<HTMLElement>('.project-grid-item, [class*="snap-start"]')
      )
      if (!items.length) {return}

      const currentScroll: number = container.scrollLeft

      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (!item) {continue}

        const itemLeft: number = item.offsetLeft

        if (itemLeft > currentScroll + 10) {
          container.scrollTo({
            left: itemLeft,
            behavior: 'smooth'
          })
          break
        }
      }
    }

    const scrollToPrev = (): void => {
      const items: HTMLElement[] = Array.from(
        container.querySelectorAll<HTMLElement>('.project-grid-item, [class*="snap-start"]')
      )
      if (!items.length) {return}

      const currentScroll: number = container.scrollLeft

      let currentItemIndex: number = -1
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (!item) {continue}

        const itemLeft: number = item.offsetLeft

        if (itemLeft >= currentScroll - 10) {
          currentItemIndex = i
          break
        }
      }

      if (currentItemIndex > 0) {
        const prevItem = items[currentItemIndex - 1]
        if (prevItem) {
          container.scrollTo({
            left: prevItem.offsetLeft,
            behavior: 'smooth'
          })
        }
      } else if (currentItemIndex === 0) {
        container.scrollTo({
          left: 0,
          behavior: 'smooth'
        })
      } else {
        for (let i = items.length - 1; i >= 0; i--) {
          const item = items[i]
          if (!item) {continue}

          const itemLeft: number = item.offsetLeft

          if (itemLeft < currentScroll - 10) {
            container.scrollTo({
              left: itemLeft,
              behavior: 'smooth'
            })
            break
          }
        }
      }
    }

    prevBtn.addEventListener('click', scrollToPrev)
    nextBtn.addEventListener('click', scrollToNext)

    container.addEventListener('scroll', updateButtonStates, { passive: true })

    const resizeObserver: ResizeObserver = new ResizeObserver(() => {
      updateButtonStates()
    })
    resizeObserver.observe(container)

    updateButtonStates()
  })
}
